// `DedupeBadge` — US-154 gap-design surface.
//
// Tiny inline pill that surfaces "duplicate detected" on a row when the
// server-side dedupe heuristic flagged this lead as having been merged with
// an earlier capture. Server-side dedupe owns the truth (Wave 6/Ext G); the
// FE just renders the flag carried on the row.
//
// We surface this as a soft warning Pill — the row stays clickable; the
// detail panel can later expose the full merge history.

import { GitMerge } from 'lucide-react';

import { useT } from '@barel/i18n';
import { Pill } from '@barel/ui';

export interface DedupeBadgeProps {
  /** When `true`, the badge renders. Falsy = renders nothing. */
  flagged: boolean | null | undefined;
}

export function DedupeBadge({ flagged }: DedupeBadgeProps) {
  const t = useT('leads');
  if (!flagged) return null;
  return (
    <Pill
      data-testid="dedupe-badge"
      tone="warning"
      variant="soft"
      size="xs"
      icon={<GitMerge size={10} aria-hidden="true" />}
    >
      {t('dedupe.badge')}
    </Pill>
  );
}
